module.exports = __webpack_public_path__ + "static/assets/f22d5ea0ef6a46b2a4a174fed722c396.svg";